import React from "react";

const modalStyles = {
  backdrop: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 99999,
  },
  modal: {
    background: "#fff",
    padding: "1.5rem",
    borderRadius: "0.5rem",
    minWidth: "300px",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    textAlign: "center",
    position: "relative",
  },
  button: {
    margin: "0.5rem",
    padding: "0.5rem 1.25rem",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "0.375rem",
    cursor: "pointer",
  },
};

export default function ConfirmModal({ isOpen, message, onConfirm, onCancel }) {
  if (!isOpen) return null;
  return (
    <div style={modalStyles.backdrop}>
      <div style={modalStyles.modal}>
        <p>{message}</p>
        <div>
          <button
            style={{ ...modalStyles.button, background: "#dc3545" }}
            onClick={onConfirm}
          >
            Yes
          </button>
          <button
            style={modalStyles.button}
            onClick={onCancel}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}
